/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiGroupOwnsNft {
    'name': ApiGroupOwnsNftNameEnum;
    'tokens': Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "name",
            "baseName": "name",
            "type": "ApiGroupOwnsNftNameEnum",
            "format": ""
        },
        {
            "name": "tokens",
            "baseName": "tokens",
            "type": "Array<string>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiGroupOwnsNft.attributeTypeMap;
    }

    public constructor() {
    }
}

export enum ApiGroupOwnsNftNameEnum {
    Memes = 'MEMES',
    Memelab = 'MEMELAB',
    Nextgen = 'NEXTGEN',
    Gradients = 'GRADIENTS'
}

